import React, {PureComponent} from 'react'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const styles = theme => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  backButton: {
    background: 'white',
    minWidth: 0,
    padding: '4px 12px',
    marginRight: 13,
    display: 'inline-block',
    marginTop: -3,
  },
  item: {
    display: 'inline-block',
    lineHeight: '32px',
    marginRight: 8,
  },
  linkItem: {
    color: theme.palette.primary[500],
    cursor: 'pointer',
  },
  separator: {
    display: 'inline-block',
    width: 3,
    height: 3,
    background: 'grey',
    borderRadius: '50%',
    marginBottom: 4,
    marginRight: 6,
  },
  subSeparator: {
    display: 'inline-block',
    color: 'grey',
    marginRight: 6,
    fontSize: 14
  },
  breadcrumbsArray: {
    display: 'inline-block',
  },
});

class ProjectBreadcrumb extends PureComponent {
  state = {};

  getPreviousView = () => {
    let previousBreadcrumb = null;
    for (let breadcrumb of this.props.breadcrumbs) {
      if (breadcrumb.action) {
        previousBreadcrumb = breadcrumb
      }
    }
    return {
      itemType: previousBreadcrumb.itemType,
      action: previousBreadcrumb.action,
      id: previousBreadcrumb.id
    }
  }

  render() {
    const {classes, name, type, update, breadcrumbs, previousPayload} = this.props;
    return (
        <div className={classes.root}>
          {breadcrumbs.length > 1 &&
          <Button variant="outlined" className={classes.backButton}
                  onClick={() => update(this.getPreviousView())}>
            <FontAwesomeIcon size="xs" icon={['fal', 'arrow-left']}/>
          </Button>}
          {breadcrumbs.map((breadcrumb, key) => {
            return (
                <React.Fragment key={key}>
                  {Array.isArray(breadcrumb) && <div className={classes.breadcrumbsArray}> {breadcrumb.map((breadcrumbItem, breadcrumbItemKey) => {
                    return (<React.Fragment key={breadcrumbItemKey}>
                      <div className={classes.item + ' ' + classes.linkItem}
                           onClick={() => update({
                             itemType: breadcrumbItem.itemType,
                             action: breadcrumbItem.action,
                             id: breadcrumbItem.id
                           })}>{breadcrumbItem.title}
                      </div>
                      {breadcrumbItemKey < breadcrumb.length - 1 && <div className={classes.subSeparator}>/</div>}
                    </React.Fragment>)
                  })}
                    <div className={classes.separator}></div>
                  </div>
                  }
                  {breadcrumb.action && <>
                    <div className={classes.item + ' ' + classes.linkItem}
                         onClick={() => update({
                           itemType: breadcrumb.itemType,
                           action: breadcrumb.action,
                           id: breadcrumb.id
                         })}>{breadcrumb.title}
                    </div>
                    <div className={classes.separator}></div>
                  </>}
                  {(!breadcrumb.action && !Array.isArray(breadcrumb)) &&
                  <div className={classes.item}>{breadcrumb.title}
                  </div>}
                </React.Fragment>
            )
          })
          }
        </div>
    )
  }
}

ProjectBreadcrumb.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectBreadcrumb);
